<template>
  <div v-if="isBannerShowing" class="bannerContainer">
    <div class="bannerContent">
      <div class="bannerText">
        <p class="bannerTitle">{{ promotionalBannerTitle }}</p>
        <p class="bannerMessage" v-html="promotionalBannerDescription"></p>
      </div>
      <img class="icon" v-on:click="closeBanner" src="/sites/all/themes/custom/meetingpackage/templatesv3/src/assets/branded-icons/close.svg" />
    </div>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      showBanner: true,
      promotionalBannerTitle: window.promotional_banner_title,
      promotionalBannerDescription: window.promotional_banner_description
    }
  },
  computed: {
    isBannerShowing() {
      return (this.promotionalBannerTitle || this.promotionalBannerDescription) && this.showBanner
    }
  },
  methods: {
    closeBanner() {
      this.showBanner = false
    }
  }
}
</script>
  
<style scoped>
  @media (min-width: 319px) {
  .bannerContent {
      max-width: 540px;
    }
  }
  @media (min-width: 639px) {
    .bannerContent {
      max-width: 720px;
    }
  }
  @media (min-width: 1023px) {
    .bannerContent {
      max-width: 960px;
    }
  }
  @media (min-width: 1279px) {
    .bannerContent {
      max-width: 1100px;
    }
  }
  .bannerContainer {
    width: 100%;
    background-color: #FDEAD8;
    color: inherit;
    font-family: inherit;
    padding: 0 16px;
  }

  .bannerContent {
    max-width: 1200px;
    width: 100%;
    padding: 16px 0;
    margin: auto;
    display: flex;
    flex-direction: row;
    align-items: start;
    column-gap: 24px;
  }
  .bannerText {
    width: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: start;
    position: relative;
    margin-left: auto;
  }

  .icon {
    height: 24px;
    width: 24px;
  }

  .icon:hover {
    cursor: pointer;
  }

  .bannerTitle {
    margin: 0;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }

  .bannerMessage {
    margin: 0;
    font-size: 16px;
    line-height: 24px;
  }
</style> 
<style>
  .bannerMessage .RichTextEditorTheme__paragraph {
    margin: 0;
  }
</style>